import { SecondaryButton } from '@designsforhealth/dfh-react-components'
import styled from 'styled-components'

import { flexboxGapStyles } from '../../../../../../lib/styles/flexbox-gap'
import OptionalProductLink from '../../../../../OptionalProductLink'

export const GapContainer = styled.div`
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  // use negative margins to workaround lack of flexbox gap support in older browsers
  ${flexboxGapStyles('10px')};
  @media print {
    // required for table layout
    display: contents;
  }
`

export const ItemDetails = styled.div`
  display: flex;
  flex-wrap: nowrap;
  min-width: 320px;
  flex: 1 0 320px;
  align-items: center;
  @media print {
    // required for table layout
    display: contents;
  }
`

export const PrintContainer = styled.div`
  @media print {
    display: table-row;
    width: 100%;
    border-bottom: 1px solid ${({ theme }) => theme.colors.coolGray.cool250};
  }
`

export const ItemImage = styled.img`
  align-self: flex-start;
  border-radius: 4px;
  height: 115px;
  width: 115px;
  min-width: 115px;
  margin-right: 16px;
  @media print {
    display: none;
  }
`

export const ItemName = styled.h4`
  max-width: 320px;
  font-family: ${({ theme }) => theme.fontFamilies.roboto};
  line-height: 1.43;
  @media print {
    flex: 1;
    display: table-cell;
    padding: 20px;
  }
`

export const ItemSku = styled.div`
  font-size: 10px;
  line-height: 1.5;
  color: ${({ theme }) => theme.colors.grayscale.gray40};
`

export const ItemAttribute = styled.div`
  color: ${({ theme }) => theme.colors.grayscale.black};
  font-size: 12px;
  line-height: 1.67;
  display: flex;
  justify-content: flex-start;
  @media print {
    display: table-cell;
    width: 100px;
    text-align: right;
    vertical-align: middle;
    padding: 20px;
  }
`

export const ItemAttributePrintOnly = styled(ItemAttribute)`
  display: none;
  @media print {
    display: table-cell;
  }
`

export const ItemAttributeNoPrint = styled(ItemAttribute)`
  @media print {
    display: none;
  }
`

export const ItemAmount = styled(ItemAttribute)`
  font-size: 14px;
  font-weight: 500;
`

export const ItemAttributeType = styled.div`
  padding-right: 5px;
  @media print {
    display: none;
  }
`

export const ItemAmountPrintOnly = styled(ItemAmount)`
  display: none;
  @media print {
    display: table-cell;
  }
`

export const AddToCartButton = styled(SecondaryButton)`
  flex: 1;
  min-width: 172px;
  @media print {
    display: none;
  }
`

export const ItemNameNoProduct = styled(ItemName)`
  color: ${({ theme }) => theme.colors.grayscale.gray40};
`

export const ItemAttributeNoProduct = styled(ItemAttribute)`
  color: ${({ theme }) => theme.colors.grayscale.gray40};
`

export const ItemAmountNoProduct = styled(ItemAmount)`
  color: ${({ theme }) => theme.colors.grayscale.gray40};
`

export const ItemAttributeTypeNoProduct = styled(ItemAttributeType)`
  color: ${({ theme }) => theme.colors.grayscale.gray40};
`

export const ButtonContainer = styled.div`
  display: flex;
  justify-content: space-around;
  flex-wrap: wrap;
  flex-direction: column;
  flex: 1;
  ${SecondaryButton} {
    margin: 0.5rem;
  }
`

export const ItemProductLink = styled(OptionalProductLink)`
  color: inherit;
  text-decoration: none;
  transition: color 0.15s;
  &:hover {
    color: ${({ theme }) => theme.colors.component.link};
  }
`
